import { Component, Input } from '@angular/core';

import { StatusFormatterService } from '../../services';

@Component({
  selector: 'ppa-status-display',
  templateUrl: './status-display.component.html',
  styleUrls: ['./status-display.component.scss'],
})
export class StatusDisplayComponent {
  @Input() status?: string;

  constructor(private statusFormatterService: StatusFormatterService) {}

  get displayText(): string {
    return this.statusFormatterService.getDisplayText(this.status || '');
  }

  get cssClass(): string {
    return this.statusFormatterService.getCssClass(this.status || '');
  }
}
